import { type AnyAction, combineReducers } from 'redux';

import type { BrandKit } from 'js/src/client';
import {
    setBrandKitsLoading,
    setSelectedBrandKitId,
    storeBrandKits,
} from 'js/src/data/brand-kits/brand-kits-actions';
import { resetSelectedBrandKit } from 'js/src/data/brand-kits-editor/brand-kits-editor-actions';
import StoreORM from 'js/src/data/store-orm';

export function list(
    state = StoreORM.newFromIdPrefix<BrandKit>('brandKits').data,
    action: AnyAction,
) {
    if (storeBrandKits.match(action)) {
        const orm = new StoreORM<BrandKit>(StoreORM.newFromIdPrefix<BrandKit>('brandKits').data);

        action.payload.brandKits.forEach((brandKit) => {
            orm.pushItem(brandKit, 'id');
        });
        return orm.data;
    }

    return state;
}

export function loading(state = true, action: AnyAction) {
    if (setBrandKitsLoading.match(action)) {
        return action.payload.flag;
    }
    return state;
}

export function selectedBrandKitId(state: number | null = null, action: AnyAction) {
    if (setSelectedBrandKitId.match(action)) {
        return action.payload;
    }
    if (resetSelectedBrandKit.match(action)) {
        return null;
    }
    return state;
}

export const brandKits = combineReducers({
    list,
    loading,
    selectedBrandKitId,
});

export type BrandKitsState = ReturnType<typeof brandKits>;
